function campoTextoOk(v) {
  return v != null && String(v).trim() !== '';
}

export function isProfileComplete(profile) {
  if (!profile) return false;
  if (profile.habilitadoParaMarket === false) return false;
  const hasNombre = campoTextoOk(profile.nombre);
  const hasPhone = campoTextoOk(profile.telefono);
  const hasAddress =
    (campoTextoOk(profile.calle) && campoTextoOk(profile.nro_casa)) ||
    campoTextoOk(profile.direccion);
  return Boolean(hasNombre && hasPhone && hasAddress);
}

/** Vendedor con perfil incompleto → forzar pantalla de datos. */
export function perfilVendedorRequiereOnboarding(profile) {
  if (!profile) return false;
  if (isProfileComplete(profile)) return false;
  return profile.rol === 'vendedor';
}
